export default "/images/FG.gif?62650beb0ca624e08fe57fa049a90ea8";